import deepmerge from 'deepmerge';
import {ENVIRONMENT_GLOBAL} from '../global_env';

export const environment = deepmerge(ENVIRONMENT_GLOBAL, {
  envName: 'dev',
  production: true,
  loggingEnabled: true,
  backend: {
    endpoint: {
      host: 'https://testapi-ai.securiton.de',
    }
  },
});
